import { Checkbox, type CheckboxProps, List } from "react-native-paper";
import Box from "../Box";
import Image from "../CustomImage";

const CHALLENGE_IMAGE_WIDTH = 56;
const CHALLENGE_IMAGE_HEIGHT = 56;

type Props = {
	title: string;
	description: string;
	imageUri: string;
	onPress: () => void;
	onCheck: () => void;
	status: CheckboxProps["status"];
};

const SavedArticleListItem = ({
	title,
	description,
	imageUri,
	onPress,
	status,
	onCheck,
}: Props) => {
	return (
		<List.Item
			title={title}
			onPress={onPress}
			description={description}
			style={{
				paddingLeft: 16,
			}}
			descriptionStyle={{
				paddingTop: 4,
			}}
			right={(_p) => (
				<Box alignSelf="center">
					<Checkbox.Android status={status} onPress={onCheck} />
				</Box>
			)}
			left={(p) => (
				<Image
					{...p}
					source={{ uri: imageUri }}
					style={{
						width: CHALLENGE_IMAGE_WIDTH,
						height: CHALLENGE_IMAGE_HEIGHT,
					}}
				/>
			)}
		/>
	);
};

export default SavedArticleListItem;
